// Filter view more js 
// function bindShowMoreButtons() {
//   document.querySelectorAll(".show-more-btn").forEach(btn => {
//     btn.onclick = () => {
//       const items = btn.previousElementSibling?.querySelectorAll(".hidden-filter");
//       if (!items?.length) return;

//       const show = items[0].style.display !== "flex";
//       items.forEach(i => i.style.display = show ? "flex" : "none");

//       btn.querySelector(".show-more-option").textContent =
//         show ? "− Show less" : "+ Show more";
//     };
//   });
// }

// ["DOMContentLoaded", "facetFilters:updated"].forEach(e =>
//   document.addEventListener(e, bindShowMoreButtons)
// );

function bindShowMoreButtons() {
  document.querySelectorAll(".show-more-btn").forEach(btn => {
    btn.onclick = () => {
      const items = btn.previousElementSibling?.querySelectorAll(".hidden-filter");
      if (!items?.length) return;

      const show = !items[0].classList.contains("show");
      items.forEach(i => i.classList.toggle("show", show));

      btn.querySelector(".show-more-option").textContent =
        show ? "− Show less" : "+ Show more";
    };
  });
}

["DOMContentLoaded", "facetFilters:updated"].forEach(e =>
  document.addEventListener(e, bindShowMoreButtons)
);


// class FacetFiltersForm extends HTMLElement {
//   constructor() {
//     super();
//     this.debounceTimeout = null;
//   }

//   connectedCallback() {
//     this.loader = document.querySelector('.facet-loader');
//     const form = this.querySelector('form');

//     if (form) {
//       form.addEventListener('input', () => {
//         clearTimeout(this.debounceTimeout);
//         this.debounceTimeout = setTimeout(() => {
//           this.submitForm(form);
//         }, 300);
//       });
//     }
//     this.querySelectorAll('.active-filter__button, .clear-all-button').forEach(button => {
//       button.addEventListener('click', (e) => {
//         e.preventDefault();
//         this.loadURL(button.href);
//       });
//     });

//     this.querySelectorAll('bz-dropdown').forEach(dropdown => {
//       dropdown.addEventListener('click', () => {
//         dropdown.dataset.open = dropdown.classList.contains('open') ? 'true' : 'false';
//       });
//     });

//     this.querySelectorAll('bz-dropdown').forEach(col => {
//       col.addEventListener('toggle', () => {
//         col.dataset.open = col.hasAttribute('open') ? "true" : "false";
//       });
//     });
//   }

//   async submitForm(form) {
//     const currentParams = new URLSearchParams(window.location.search);
//     const formData = new FormData(form);

//     const keysToUpdate = new Set();
//     for (const [key] of formData.entries()) {
//       keysToUpdate.add(key);
//     }

//     keysToUpdate.forEach(key => currentParams.delete(key));

//     for (const [key, value] of formData.entries()) {
//       currentParams.append(key, value);
//     }

//     const url = `${window.location.pathname}?${currentParams.toString()}`;
//     this.loadURL(url);
//   }

//   async loadURL(url) {
//     this.loader?.classList.remove('hidden');

//     const collapseStates = {};
//     document.querySelectorAll('bz-dropdown').forEach((col, i) => {
//       collapseStates[i] = col.hasAttribute('open');
//     });

//     const inputValues = {};
//     this.querySelectorAll('input').forEach(input => {
//       inputValues[input.name] = input.value;
//     });

//     const response = await fetch(url);
//     const html = await response.text();
//     const doc = new DOMParser().parseFromString(html, 'text/html');

//     const newGrid = doc.querySelector('.collection-products');
//     const oldGrid = document.querySelector('.collection-products');
//     if (newGrid && oldGrid) oldGrid.replaceWith(newGrid);

//     const newFilters = doc.querySelector('facet-filters-form');
//     const oldFilters = document.querySelector('facet-filters-form');
//     if (newFilters && oldFilters) oldFilters.replaceWith(newFilters);

//     document.querySelectorAll('facet-filters-form .active-filter__button, facet-filters-form .clear-all-button')
//       .forEach(button => {
//         button.addEventListener('click', (e) => {
//           e.preventDefault();
//           this.loadURL(button.href);
//         });
//       });
    
//     let index = 0;
//     document.querySelectorAll('bz-dropdown').forEach(col => {
//       if (collapseStates[index]) {
//         col.setAttribute('open', '');
//       } else {
//         col.removeAttribute('open');
//       }
//       index++;
//     });

//     Object.entries(inputValues).forEach(([name, value]) => {
//       const input = this.querySelector(`input[name="${name}"]`);
//       if (input) input.value = value;
//     });

//     history.pushState({}, '', url);
//     this.loader?.classList.add('hidden');
//     document.dispatchEvent(new CustomEvent("facetFilters:updated"));
//   }

//   reopenDropdowns() {
//     this.querySelectorAll('bz-dropdown').forEach(dropdown => {
//       if (dropdown.dataset.open === 'true') dropdown.classList.add('open');
//     });
//     this.querySelectorAll('bz-dropdown').forEach(col => {
//       if (col.dataset.open === 'true') {
//         col.setAttribute('open', '');
//       } else {
//         col.removeAttribute('open');
//       }
//     });
//   }
// }

// customElements.define('facet-filters-form', FacetFiltersForm);

// working js

// grid-list view
  // (function () {

  //   const STORAGE_KEY = 'productLayout';

  //   function getLayout() {
  //     return localStorage.getItem(STORAGE_KEY) || 'grid';
  //   }

  //   function applyLayout() {
  //     const grid = document.getElementById('ProductGrid');
  //     if (!grid) {
  //       return;
  //     }

  //     const layout = getLayout();

  //     grid.classList.remove('product-grid', 'product-list');

  //     if (layout === 'list') {
  //       grid.classList.add('product-list');
  //     } else {
  //       grid.classList.add('product-grid');
  //     }
  //   }

  //   function updateButtons() {
  //     const layout = getLayout();

  //     document.querySelectorAll('.bzlistgridbtn').forEach(btn => {
  //       btn.classList.remove('active', 'active_mobile');

  //       if (
  //         (layout === 'grid' && btn.classList.contains('gridv')) ||
  //         (layout === 'list' && btn.classList.contains('listv'))
  //       ) {
  //         btn.classList.add('active');
  //         if (window.innerWidth < 992) {
  //           btn.classList.add('active_mobile');
  //         }
  //       }
  //     });
  //   }

  //   function handleToggle(e) {
  //     const btn = e.target.closest('.bzlistgridbtn');
  //     if (!btn) return;

  //     const layout = btn.classList.contains('listv') ? 'list' : 'grid';

  //     localStorage.setItem(STORAGE_KEY, layout);
  //     applyLayout();
  //     updateButtons();
  //   }

  //   document.addEventListener('DOMContentLoaded', () => {
  //     applyLayout();
  //     updateButtons();
  //   });
  //   document.addEventListener('shopify:section:load', () => {
  //     applyLayout();
  //     updateButtons();
  //   });
  //   document.addEventListener('shopify:section:unload', () => {
  //     applyLayout();
  //     updateButtons();
  //   });
  //   document.addEventListener('shopify:section:select', () => {
  //     applyLayout();
  //     updateButtons();
  //   });
  //   document.addEventListener('shopify:section:deselect', () => {
  //     applyLayout();
  //     updateButtons();
  //   });
  //   document.addEventListener('shopify:section:reorder', () => {
  //     applyLayout();
  //     updateButtons();
  //   });

  //   document.addEventListener('click', handleToggle);

  //   document.addEventListener('facetFilters:updated', () => {
  //       applyLayout();
  //       updateButtons();
  //   });

  // })();
  (function () {
    const STORAGE_KEY = 'productLayout';
    const GRID_ID = 'ProductGrid';

    function getDefaultLayout() {
      const el = document.querySelector('[data-default-layout]');
      return el && el.dataset.defaultLayout === 'list' ? 'list' : 'grid';
    }

    function getLayout() {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'list' || stored === 'grid') return stored;
      return getDefaultLayout();
    }

    function applyLayout() {
      const grid = document.getElementById(GRID_ID);
      if (!grid) return;

      const layout = getLayout();

      grid.classList.toggle('product-grid', layout === 'grid');
      grid.classList.toggle('product-list', layout === 'list');
    }

    function updateButtons() {
      const layout = getLayout();
      const isMobile = window.innerWidth < 992;

      document.querySelectorAll('.bzlistgridbtn').forEach(btn => {
        const isActive =
          (layout === 'grid' && btn.classList.contains('gridv')) ||
          (layout === 'list' && btn.classList.contains('listv'));

        btn.classList.toggle('active', isActive);
        btn.classList.toggle('active_mobile', isActive && isMobile);
        btn.setAttribute('aria-pressed', isActive);
      });
    }

    function refreshUI() {
      applyLayout();
      updateButtons();
    }

    function toggleFromButton(btn) {
      const layout = btn.classList.contains('listv') ? 'list' : 'grid';
      localStorage.setItem(STORAGE_KEY, layout);
      refreshUI();
    }

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.bzlistgridbtn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggleFromButton(btn);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const btn = e.target.closest('.bzlistgridbtn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggleFromButton(btn);
    });

    document.addEventListener('DOMContentLoaded', refreshUI);
    document.addEventListener('facetFilters:updated', refreshUI);
    document.addEventListener('shopify:section:load', () => {
      if (window.Shopify && window.Shopify.designMode) {
        localStorage.removeItem(STORAGE_KEY);
      }
      refreshUI();
    });
})();


// filter
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debounceTimeout = null;
  }

  connectedCallback() {
    if (this._bound) return;
    this._bound = true;
    this.loader = document.querySelector('.facet-loader');
    this.form = this.querySelector('form');

    if (this.form) {
      this.form.addEventListener('input', (e) => {
        if (e.target.closest('.filter-price-slider')) {
          this.syncPriceFromRange(e.target);
        }
        this.debouncedSubmit(this.form);
      });
    }

    this.bindFilterButtons();
  }

  syncPriceFromRange(rangeEl) {
    const wrap = rangeEl.closest('.filter-price-control');
    if (!wrap) return;

    const minEl = wrap.querySelector('.filter-price-slider-min');
    const maxEl = wrap.querySelector('.filter-price-slider-max');
    const nums = wrap.querySelectorAll('.filter-price-range input');
    const label = wrap.querySelector('.filter-price-val');
    const bar = wrap.querySelector('.filter-price-slider');
    if (!minEl || !maxEl || nums.length < 2) return;

    let lo = Number(minEl.value);
    let hi = Number(maxEl.value);
    const cap = Number(minEl.max) || 0;
    if (lo > hi) {
      const swap = lo;
      lo = hi;
      hi = swap;
    }
    minEl.value = lo;
    maxEl.value = hi;
    nums[0].value = lo;
    nums[1].value = hi;
    if (bar && cap > 0) {
      bar.style.setProperty('--price-a', `${(lo / cap) * 100}%`);
      bar.style.setProperty('--price-b', `${(hi / cap) * 100}%`);
    }
    if (label) {
      const symbol = label.dataset.symbol || '';
      label.textContent = `${symbol}${lo} – ${symbol}${hi}`;
    }
  }

  debouncedSubmit(form) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.submitForm(form);
    }, 300);
  }

  bindFilterButtons() {
    this.querySelectorAll('.active-filter__button, .clear-all-button').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadURL(button.href);
      });
    });

    this.querySelectorAll('bz-dropdown.filters__disclosure, bz-dropdown.sorting').forEach(dropdown => {
      const panel = dropdown.querySelector('.drop_content');
      if (panel && !panel._filterPanelBound) {
        panel._filterPanelBound = true;
        const keepOpen = (e) => e.stopPropagation();
        panel.addEventListener('pointerdown', keepOpen);
        panel.addEventListener('click', keepOpen);
      }
      dropdown.addEventListener('toggle', () => {
        dropdown.dataset.open = dropdown.hasAttribute('open') ? 'true' : 'false';
        if (!dropdown.hasAttribute('open')) return;
        this.querySelectorAll('bz-dropdown.filters__disclosure, bz-dropdown.sorting').forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open');
        });
      });
    });
  }

  // async submitForm(form) {
  //   const currentParams = new URLSearchParams(window.location.search);
  //   const formData = new FormData(form);

  //   const keysToUpdate = new Set();
  //   for (const [key] of formData.entries()) keysToUpdate.add(key);
  //   keysToUpdate.forEach(key => currentParams.delete(key));

  //   for (const [key, value] of formData.entries()) {
  //     currentParams.append(key, value);
  //   }

  //   const url = `${window.location.pathname}?${currentParams.toString()}`;
  //   this.loadURL(url);
  // }

  async submitForm(form) {
    const currentParams = new URLSearchParams(window.location.search);
    const formData = new FormData(form);

    currentParams.delete('page');

    const allFilterNames = new Set();
    form.querySelectorAll('input.input_checkbox, input.input_radio, input.input_number, select')
      .forEach(el => {
        if (el.name) allFilterNames.add(el.name);
      });

    allFilterNames.forEach(name => {
      currentParams.delete(name);
    });

    for (const [key, value] of formData.entries()) {
      currentParams.append(key, value);
    }

    const url = `${window.location.pathname}?${currentParams.toString()}`;
    this.loadURL(url);
  }

  // async loadURL(url) {
  //   this.loader?.classList.remove('hidden');

  //   const collapseStates = {};
  //   document.querySelectorAll('bz-dropdown').forEach((col, i) => {
  //     collapseStates[i] = col.hasAttribute('open');
  //   });

  //   const response = await fetch(url);
  //   const html = await response.text();
  //   const doc = new DOMParser().parseFromString(html, 'text/html');

  //   const newGrid = doc.querySelector('.collection-product');
  //   const oldGrid = document.querySelector('.collection-product');
  //   if (newGrid && oldGrid) oldGrid.replaceWith(newGrid);

  //   const newForms = doc.querySelectorAll('facet-filters-form');
  //   const oldForms = document.querySelectorAll('facet-filters-form');

  //   oldForms.forEach((oldForm, index) => {
  //     const newForm = newForms[index];
  //     if (newForm) {
  //       oldForm.replaceWith(newForm);
  //       newForm.connectedCallback();
  //     }
  //   });

  //   let index = 0;
  //   document.querySelectorAll('bz-dropdown').forEach(col => {
  //     if (collapseStates[index]) col.setAttribute('open', '');
  //     else col.removeAttribute('open');
  //     index++;
  //   });

  //   history.pushState({}, '', url);
  //   this.loader?.classList.add('hidden');
  //   document.dispatchEvent(new CustomEvent("facetFilters:updated"));
  // }

  async loadURL(url) {
    this.loader?.classList.remove('hidden');

    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.delete('page');

    if (!urlObj.searchParams.has('sort_by')) {
      urlObj.searchParams.set('sort_by', 'best-selling');
    }
    url = urlObj.toString();

    const collapseStates = {};
    document.querySelectorAll('bz-dropdown[data-dropdown-id]').forEach((col) => {
      collapseStates[col.getAttribute('data-dropdown-id')] = col.hasAttribute('open');
    });
    document.querySelectorAll('bz-dropdown.sorting').forEach((col, i) => {
      collapseStates[`sorting-${i}`] = col.hasAttribute('open');
    });

    const response = await fetch(url);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    updateFilterProductCountFromDoc(doc);
    
    const newGrid = doc.querySelector('.collection-product, .collection--empty');
    const oldGrid = document.querySelector('.collection-product, .collection--empty');
    if (newGrid && oldGrid) oldGrid.replaceWith(newGrid);

    const newForms = [...doc.querySelectorAll('facet-filters-form')];
    const used = new Set();
    document.querySelectorAll('facet-filters-form').forEach((oldForm) => {
      const formId = oldForm.querySelector('form')?.id;
      if (!formId) return;
      const newForm = newForms.find((f) => !used.has(f) && f.querySelector('form')?.id === formId);
      if (!newForm) return;
      used.add(newForm);
      oldForm.replaceWith(newForm);
    });
    document.querySelectorAll('bz-dropdown[data-dropdown-id]').forEach((col) => {
      const id = col.getAttribute('data-dropdown-id');
      if (collapseStates[id]) col.setAttribute('open', '');
    });
    document.querySelectorAll('bz-dropdown.sorting').forEach((col, i) => {
      if (collapseStates[`sorting-${i}`]) col.setAttribute('open', '');
    });
    history.pushState({}, '', url);
    this.loader?.classList.add('hidden');
    document.dispatchEvent(new CustomEvent("facetFilters:updated"));
  }
}
if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

// product count update
function updateFilterProductCountFromDoc(doc) {
  const target = document.getElementById('FilterProdCount');
  if (!target || !doc) return;

  const newCount =
    doc.getElementById('FilterProdCount') ||
    doc.querySelector('.filter-prod-count-text') ||
    doc.querySelector('[data-product-count]');

  if (newCount) {
    target.textContent = newCount.textContent.trim();
    return;
  }
}

// loadmore
(function () {
  const sel = '[data-coll-pager]';
  let loading = false;
  let io;

  async function loadNext(pager) {
    if (loading || !pager || !pager.dataset.next) return;
    loading = true;
    pager.classList.add('is-loading');
    try {
      const url = new URL(pager.dataset.next, location.origin);
      if (pager.dataset.section) url.searchParams.set('section_id', pager.dataset.section);
      const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
      const grid = document.getElementById('ProductGrid');
      const incoming = doc.getElementById('ProductGrid');
      if (grid && incoming) {
        incoming.querySelectorAll(':scope > li').forEach((li) => {
          li.classList.add('reveal_visible');
          grid.appendChild(li);
        });
      }
      const next = doc.querySelector(sel);
      if (next && next.dataset.next) {
        pager.dataset.next = next.dataset.next;
        const status = pager.querySelector('[data-coll-pager-status]');
        const fresh = next.querySelector('[data-coll-pager-status]');
        if (status && fresh) status.innerHTML = fresh.innerHTML;
      } else {
        io?.disconnect();
        pager.remove();
      }
    } catch (err) {}
    loading = false;
    pager.classList.remove('is-loading');
  }

  function bindPager() {
    io?.disconnect();
    const pager = document.querySelector(sel);
    if (!pager) return;
    const btn = pager.querySelector('[data-coll-pager-btn]');
    if (btn) btn.onclick = () => loadNext(pager);
    if (pager.dataset.mode !== 'infinite') return;
    io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) loadNext(pager);
    }, { rootMargin: '240px' });
    io.observe(pager);
  }

  document.addEventListener('DOMContentLoaded', bindPager);
  document.addEventListener('facetFilters:updated', bindPager);
})();